import React, { PureComponent } from 'react';
import './GDPR.css';

const GDPR_KEY = 'USER_GDPR_ANSWER';
const ACCEPTED = 'ACCEPTED';

const PDF_URL = `${process.env.PUBLIC_URL}/mds_privacy_policy.pdf`;

export default class GDPR extends PureComponent {
    state = {
        showBanner: false,
        isCheckboxChecked: false
    }

    componentDidMount() {
        const hasAccepted = localStorage.getItem(GDPR_KEY);

        if (hasAccepted !== ACCEPTED) {
            this.setState({
                showBanner: true
            });
        }
    }

    onCheckboxChange = (e) => {
        this.setState({
            isCheckboxChecked: e.target.checked
        });
    }

    onAccept = () => {
        localStorage.setItem(GDPR_KEY, ACCEPTED);

        this.setState({
            showBanner: false
        });
    }

    render() {
        if (!this.state.showBanner) {
            return null;
        }

        return (
            <div className='GDPR'>
                <p>
                    I have read and agree with the

                    <a href={PDF_URL} target='_blank'>
                        Terms&Conditions and Privacy&Data policy
                    </a>

                    <input type='checkbox' onChange={this.onCheckboxChange} />

                    <br/><br/>

                    <button
                        onClick={this.onAccept}
                        disabled={!this.state.isCheckboxChecked}>
                        Accept
                    </button>
                </p>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/GDPR/GDPR.js